(() => {
  if (customElements.get('kr-diy-cart-design')) return;
  customElements.define('kr-diy-cart-design', class extends HTMLElement {
    connectedCallback() {
      this.handleClick ??= event => {
        const button = event.target.closest?.('button');
        if (button?.closest('kr-diy-cart-design') === this) {
          if (button.hasAttribute('data-edit')) {
            event.preventDefault();
            this.open();
          } else if (button.hasAttribute('data-close')) {
            if (!this.pending) this.dialog?.close();
          } else if (button.hasAttribute('data-save')) {
            this.save();
          } else if (button.hasAttribute('data-charm') && !this.pending && this.slots) {
            this.slots[this.active] = button.dataset.charm;
            this.paint();
          } else if (button.hasAttribute('data-slot') && !this.pending && this.slots) {
            this.active = Number(button.dataset.slot);
            this.paint();
            this.querySelector('[data-slots]').children[this.active]?.focus();
          }
        }
        if (event.target === this.dialog && !this.pending) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      };
      this.handleCancel ??= event => {
        if (event.target === this.dialog && this.pending) event.preventDefault();
      };
      this.handleClose ??= event => {
        if (event.target === this.dialog) this.querySelector('[data-edit]')?.focus({ preventScroll: true });
      };
      this.addEventListener('click', this.handleClick);
      this.addEventListener('cancel', this.handleCancel, true);
      this.addEventListener('close', this.handleClose, true);
    }
    readConfig() {
      this.dialog = this.querySelector('dialog');
      this.status = this.querySelector('[data-status]');
      try {
        if (!this.dialog?.showModal || !this.status) throw Error('markup');
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        const properties = Array.isArray(this.config.properties) ? Object.fromEntries(this.config.properties) : this.config.properties;
        try {
          this.original = JSON.parse(properties._kinriot_design);
        } catch (_) {
          const encoded = properties._kinriot_design;
          if (typeof encoded !== 'string') throw Error('design');
          this.original = JSON.parse(encoded.replace(/&quot;|&#0*34;|&#x0*22;/gi, '"'));
        }
        this.choices = [...this.querySelectorAll('[data-charm]')];
        this.catalog = new Map(this.choices.map(button => [button.dataset.charm, { name: button.dataset.name, image: button.querySelector('img')?.getAttribute('src') }]));
        const count = ['L', 'XL'].includes(this.original.size) ? 5 : ['S', 'M'].includes(this.original.size) ? 3 : 0;
        if (!count || !Array.isArray(this.original.slots) || this.original.slots.length !== count || this.original.slots.some(id => !this.catalog.has(id))) throw Error('design');
        this.querySelector('[data-editor-error]')?.setAttribute('hidden', '');
        return true;
      } catch (_) {
        this.querySelector('[data-editor-error]')?.removeAttribute('hidden');
        return false;
      }
    }
    open() {
      if (this.pending || !this.readConfig()) return;
      this.slots = [...this.original.slots];
      this.active = 0;
      this.status.textContent = '';
      this.querySelector('[data-fulfillment]').value = this.original.fulfillment === 'kit' ? 'kit' : 'assembled';
      this.paint();
      this.dialog.showModal();
      this.querySelector('[data-slots] button')?.focus();
    }
    paint(){
      const root=this.querySelector('[data-slots]');root.replaceChildren();
      this.slots.forEach((id,index)=>{const button=document.createElement('button');button.type='button';button.dataset.slot=String(index);button.setAttribute('aria-label',`${this.config.labels.position} ${index+1}: ${this.catalog.get(id).name}`);button.setAttribute('aria-pressed',String(this.active===index));button.append(String(index+1));const source=this.catalog.get(id).image;if(source){const img=document.createElement('img');img.src=source;img.alt='';img.width=35;img.height=35;button.append(img);}button.disabled=Boolean(this.pending);root.append(button);});
      this.choices.forEach(button=>{button.setAttribute('aria-pressed',String(this.slots[this.active]===button.dataset.charm));button.disabled=Boolean(this.pending);});
    }
    async save(){
      if(this.pending)return;
      this.pending=true;this.status.textContent=this.config.labels.saving;this.querySelector('[data-save]').disabled=true;this.querySelector('[data-close]').disabled=true;this.querySelector('[data-fulfillment]').disabled=true;this.paint();
      const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),12000);
      try{
        const root=new URL(this.dataset.root,location.origin),cartPage=new URL(this.dataset.cartUrl,location.origin);
        if(root.origin!==location.origin||cartPage.origin!==location.origin)throw Error('origin');
        const cartUrl=new URL('cart.js',root),changeUrl=new URL('cart/change.js',root);
        const currentResponse=await fetch(cartUrl,{credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:'application/json'}});
        if(!currentResponse.ok)throw Error('cart');const current=await currentResponse.json();const line=current.items?.find(item=>item.key===this.config.key);
        if(!line||line.quantity<1){this.status.textContent=this.config.labels.stale;return;}
        const receive=this.querySelector('[data-fulfillment]').value==='kit'?'kit':'assembled';
        const design={...this.original,slots:[...this.slots],fulfillment:receive};
        const properties={...line.properties,'Receive as':receive==='kit'?'DIY kit':'Assembled for you','_kinriot_design':JSON.stringify(design)};
        this.slots.forEach((id,index)=>{properties[`Position ${index+1}`]=this.catalog.get(id).name;});
        const response=await fetch(changeUrl,{method:'POST',credentials:'same-origin',signal:controller.signal,headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.key,quantity:line.quantity,properties})});
        if(!response.ok)throw Error('change');const updated=await response.json();
        if(!updated.items?.some(item=>item.id===line.id&&item.properties?._kinriot_design===properties._kinriot_design))throw Error('unconfirmed');
        location.assign(cartPage.href);
      }catch(_){this.status.textContent=this.config.labels.error;}
      finally{clearTimeout(timeout);this.pending=false;this.querySelector('[data-save]').disabled=false;this.querySelector('[data-close]').disabled=false;this.querySelector('[data-fulfillment]').disabled=false;this.paint();}
    }
    disconnectedCallback(){this.removeEventListener('click',this.handleClick);this.removeEventListener('cancel',this.handleCancel,true);this.removeEventListener('close',this.handleClose,true);if(this.dialog?.open)this.dialog.close();}
  });
})();

